module.exports = __webpack_public_path__ + "media/images/help/about/bg-mv-8ec5febe1ef31afa5875044c73f41993.svg";